<template>
  <PEnviarChaveAcesso />
</template>

<script>
import PEnviarChaveAcesso from '@/components/p-enviar-chave-acesso/index.vue';

export default {
  components: {
    PEnviarChaveAcesso,
  },
};
</script>
